
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sofortbildkamera-mieten",
      function () {
        return require("private-next-pages/sofortbildkamera-mieten.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sofortbildkamera-mieten"])
      });
    }
  